/* eslint-disable react/prop-types */
// TODO import all lodash is not necessary @see {@link https://www.blazemeter.com/blog/the-correct-way-to-import-lodash-libraries-a-benchmark }

import React, {Component} from 'react';

import {throttle} from 'lodash';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import * as loadingActions from '@/actions/loadingActions';
import {updateManualControlState} from '@/actions/manualControlActions';
import * as setupActions from '@/actions/setupActions';
import HelpIcon from '@/assets/icons/Question.svg';
import {
  pauseAutoProfile,
  postHighVolumeBuffer,
  resumeAutoProfile,
  startManualControlOnHold,
  stopAutoProfile,
  stopManualControlOnHold,
  validateAutoProfileParams,
  validateAutoProfileParamsBeforeSchedule,
} from '@/businesses/autoProfileBusiness';
import {
  PostEnableManualUpdate,
  PostStartManualUpdate,
  PostStopManualUpdate,
  PostCancelManualControl,
} from '@/businesses/fetchManualControl';
import {startManualControl} from '@/businesses/manualControlBusiness';
import PopUpWizard from '@/components/popup/PopUpWizard';
import {RecoveryOfLiquidAction} from '@/constants/autoProfileEnum';
import {VERSION_3} from '@/constants/constant';
import * as APPDATA from '@/constants/pcConstAppData';
import {AutoProfileEvent, ManualControlEventTopMenu, RecoveryOfLiquidEvent} from '@/constants/pubSubEnum';
import {MANUAL_CONTROL_ENUM} from '@/constants/statusManualControlEnum';
import {consoleLog} from '@/libs/consoleHelper';
import {eventBusObject} from '@/observers/eventBus';

import {
  DataHelpHome,
  DataHelpConcentrate,
  DataHelpConcentrateMoreThan50,
  DataHelpBufferDiscrete,
  DataHelpBufferContinuous,
  DataHelpAdvancedSetup,
  DataHelpManualControl,
  DataHelpStatusAndGraph,
  DataHelpRecovery,
} from '../help/AutoProfileHelp';

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  lockAccess: store.setupStore.lockAccess,
  isPCRunning: store.setupStore.isPCRunning,
  isPCPaused: store.setupStore.isPCPaused,
  currentPCState: store.setupStore.currentPCState,
  isManualControlEnable: store.manualControlStore.StatusManualControl?.IsManualControlEnable,
  isManualControlRunning: store.manualControlStore.StatusManualControl?.IsManualControlRunning,
  ManualControlState: store.manualControlStore.ManualControlState,
  IsHoldToRunActive: store.manualControlStore.IsHoldToRunActive,
  RequestPendingManualControl: store.manualControlStore.RequestPendingManualControl,
  isCompleteFill: store.setupStore.isCompleteFill,
  modeHelp: store.setupStore.modeHelp,
  deviceVersion: store.setupStore.deviceVersion,
  isSetScheduleRun: store.schedulerState.isSetScheduleRun,
  isScheduleWillRun: store.schedulerState.isScheduleWillRun,
}))

// TODO because of the code complexity and maintain purpose this component should break down into a separate child component
class AutoProfileTopMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHelpModeEnable: false,
      contentHelp: DataHelpHome,
      waitingPause: false,
    };

    this._bus = eventBusObject();
    this.resumeSuccess = this.resumeSuccess.bind(this);
    this.resumeFailed = this.resumeFailed.bind(this);
    this.pauseSuccess = this.pauseSuccess.bind(this);
    this.pauseFailed = this.pauseFailed.bind(this);

    this.endLongPressAction = this.endLongPressAction.bind(this);
    this.startLongPressAction = this.startLongPressAction.bind(this);
    this.backAction = this.backAction.bind(this);
    this.onClick = this.onClick.bind(this);
    this.setSingleTopMenuProperties = this.setSingleTopMenuProperties.bind(this);
    this.setDoubleTopMenuProperties = this.setDoubleTopMenuProperties.bind(this);
    this.throttleStopAutoProfile = throttle(
      () => {
        const {dispatch} = this.props;
        dispatch(stopAutoProfile());
      },
      1000,
      {leading: true, trailing: false},
    );
  }

  componentDidMount() {
    const {dispatch, activeTopMenu, titleTopMenu, isCompleteFill} = this.props;
    this.eventHelpMenu = this._bus.subscribe(AutoProfileEvent.OpenHelpMenu, () => this.onClickHelp());
    this.eventEnablemanualControl = this._bus.subscribe(ManualControlEventTopMenu.EnableManualControlTopMenu, () =>
      this.EnableManualUpdate(),
    );
    this.eventStartManualControl = this._bus.subscribe(ManualControlEventTopMenu.StartManualControlTopMenu, () =>
      dispatch(startManualControl()),
    );
    this.eventStopManualControl = this._bus.subscribe(ManualControlEventTopMenu.StopManualControlTopMenu, () =>
      this.StopManualControl(),
    );
    this.eventStartManualControlOnHold = this._bus.subscribe(
      ManualControlEventTopMenu.StartManualControlOnHoldTopMenu,
      () => this.StartManualControlOnHold(),
    );
    this.eventStopManualControlOnHold = this._bus.subscribe(
      ManualControlEventTopMenu.StopManualControlOnHoldTopMenu,
      () => this.StopManualControlOnHold(),
    );
    this.eventCancelManualControl = this._bus.subscribe(ManualControlEventTopMenu.CancelManualControlTopMenu, () =>
      this.CancelManualControl(),
    );

    if (activeTopMenu !== undefined) dispatch(setupActions.updateActiveMenu(activeTopMenu));
    dispatch(setupActions.setTitleMenuProperties(titleTopMenu));
    this.subscriptionTopButtonStatusType = this._bus.subscribe(APPDATA.EVENT.TopButtonStatusTypeAutoProfile, (arg) =>
      this.onChangeTopButtonProps(arg),
    );
    this.setupTopMenuProperties(!isCompleteFill, this.props);
    // this.prepareAutoProfileHelp();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateSaveButton(nextProps);
  }

  componentWillUnmount() {
    this.eventHelpMenu.unsubscribe();
    this.eventEnablemanualControl.unsubscribe();
    this.eventStartManualControl.unsubscribe();
    this.eventStopManualControl.unsubscribe();
    this.eventStartManualControlOnHold.unsubscribe();
    this.eventStopManualControlOnHold.unsubscribe();
    this.eventCancelManualControl.unsubscribe();
    this.subscriptionTopButtonStatusType.unsubscribe();
  }

  updateSaveButton = (nextProps) => {
    const {
      isManualControlRunning,
      modeHelp,
      lockAccess,
      isCompleteFill,
      isPCPaused,
      ManualControlState,
      isManualControlEnable,
      isPCRunning,
      isSetScheduleRun,
      isScheduleWillRun,
    } = this.props;

    if (modeHelp !== nextProps.modeHelp) {
      let content;
      switch (nextProps.modeHelp) {
        case APPDATA.HOME_HELP:
          content = DataHelpHome;
          break;
        case APPDATA.CONCENTRATE_HELP:
          content = DataHelpConcentrate;
          break;
        case APPDATA.CONCENTRATE50ML_HELP:
          content = DataHelpConcentrateMoreThan50;
          break;
        case APPDATA.BUFFER_DISCRETE_HELP:
          content = DataHelpBufferDiscrete;
          break;
        case APPDATA.BUFFER_CONTINOUS_HELP:
          content = DataHelpBufferContinuous;
          break;
        case APPDATA.ADVANCED_SETUP_HELP:
          content = DataHelpAdvancedSetup;
          break;
        case APPDATA.MANUAL_CONTROL_HELP:
          content = DataHelpManualControl;
          break;
        case APPDATA.STATUS_GRAPH_HELP:
          content = DataHelpStatusAndGraph;
          break;
        case APPDATA.RECOVERY_HELP:
          content = DataHelpRecovery;
          break;
        default:
          content = DataHelpHome;
          break;
      }
      this.setState(
        {
          contentHelp: content,
        },
        () => {
          this.setupTopMenuProperties(!nextProps.isCompleteFill, nextProps);
        },
      );
    }

    if (
      isManualControlRunning !== nextProps.isManualControlRunning ||
      lockAccess !== nextProps.lockAccess ||
      isPCPaused !== nextProps.isPCPaused ||
      isCompleteFill !== nextProps.isCompleteFill ||
      ManualControlState !== nextProps.ManualControlState ||
      isManualControlEnable !== nextProps.isManualControlEnable ||
      isSetScheduleRun !== nextProps.isSetScheduleRun ||
      isScheduleWillRun !== nextProps.isScheduleWillRun
    ) {
      this.setupTopMenuProperties(!nextProps.isCompleteFill, nextProps);
    }

    if (isPCRunning !== nextProps.isPCRunning) {
      this.setupTopMenuProperties(nextProps.isPCRunning, nextProps);
    }
  };

  setupTopMenuHiddenHelpProperties = (hideButtonDefault) => {
    const {isRemoteView, titleTopMenu} = this.props;

    const ButtonRunProperties = {
      id: APPDATA.RUN_NOW,
      label: APPDATA.RUN_NOW,
      onClick: this.onClick,
      disabled: hideButtonDefault,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: this.backAction,
    };
    const titleMenuProperties = titleTopMenu;
    const secondaryButton = undefined;
    this.setSingleTopMenuProperties(
      ButtonRunProperties,
      isRemoteView === true ? undefined : backButtonProperties,
      titleMenuProperties,
      secondaryButton,
    );
  };

  setupTopMenuProperties = (hideButtonDefault, props) => {
    const {
      isPCRunning,
      isPCPaused,
      lockAccess,
      ManualControlState,
      // statusManualControl,
      isRemoteView,
      titleTopMenu,
      isSetScheduleRun,
      isScheduleWillRun,
      isManualControlEnable,
      isManualControlRunning,
      deviceVersion,
    } = props;

    this.forceUpdate();
    const disablePauseStopButton = !isPCRunning ? true : !!lockAccess;

    // if (String(statusManualControl.IsManualControlRunning) === 'true') {
    //   disableFinnishButton = true;
    // }
    const ButtonSchedulerProperties = {
      id: APPDATA.SCHEDULE_RUN,
      label: isSetScheduleRun || isScheduleWillRun ? APPDATA.EDIT_SCHEDULE : APPDATA.SCHEDULE_RUN,
      onClick: this.onClick,
      disabled: isScheduleWillRun || hideButtonDefault,
      className: isSetScheduleRun || isScheduleWillRun ? ' pause-button ' : ' primary-outline-button ',
    };
    const ButtonRunProperties = {
      id: APPDATA.RUN_NOW,
      label: APPDATA.RUN_NOW,
      onClick: this.onClick,
      disabled: hideButtonDefault,
    };
    const ButtonPauseProps = {
      id: APPDATA.PAUSE.toUpperCase(),
      label: APPDATA.PAUSE.toUpperCase(),
      onClick: this.onClick,
      disabled: disablePauseStopButton,
      className: ' pause-button ',
    };
    const ButtonContinueProps = {
      id: APPDATA.CONTINUE.toUpperCase(),
      label: APPDATA.CONTINUE.toUpperCase(),
      onClick: this.onClick,
      disabled: String(isManualControlRunning) === 'true' || disablePauseStopButton,
      className: ' resume-button ',
    };
    const ButtonStopProps = {
      id: RecoveryOfLiquidAction.STOP_NORMAL_PROCESS,
      label: APPDATA.STOP,
      onClick: this.onClick,
      disabled: disablePauseStopButton,
      className: ' stop-button ',
    };
    const ButtonStopManualControl = {
      id: RecoveryOfLiquidAction.STOP_MANUAL_CONTROL,
      label: APPDATA.CANCEL.toUpperCase(),
      onClick: this.onClick,
      disabled: disablePauseStopButton,
      className: ' resume-button',
    };
    const ButtonFinishProps = {
      id: APPDATA.FINISH,
      label: APPDATA.FINISH,
      onClick: this.onClick,
      disabled: String(isManualControlRunning) === 'true' || disablePauseStopButton,
      className: ' finish-button ',
    };
    const ButtonHoldToRunProps = {
      id: 'HOLD_TO_RUN',
      label: 'HOLD TO RUN',
      // onClick : this.onClick,
      disabled: disablePauseStopButton,
      className: ' resume-button',
      enableLongPress: true,
      endLongPress: this.endLongPressAction,
      startLongPress: this.startLongPressAction,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: this.backAction,
    };
    const titleMenuProperties = titleTopMenu;

    const secondaryButton = {
      id: 'AutoProfileHelp',
      onClick: this.onClick,
      className: 'help-icon',
      icon: HelpIcon,
      disabled: false,
    };
    if (!props.isPCRunning) {
      backButtonProperties.disabled = false;
      if (isScheduleWillRun || isSetScheduleRun) backButtonProperties.disabled = true;
      if (deviceVersion === VERSION_3) {
        if (props.isSetScheduleRun || props.isScheduleWillRun) {
          this.setSingleTopMenuProperties(
            ButtonSchedulerProperties,
            isRemoteView === true ? undefined : backButtonProperties,
            titleMenuProperties,
            secondaryButton,
          );
        } else {
          this.setDoubleTopMenuProperties(
            ButtonSchedulerProperties,
            ButtonRunProperties,
            isRemoteView === true ? undefined : backButtonProperties,
            titleMenuProperties,
            secondaryButton,
          );
        }
      } else {
        this.setSingleTopMenuProperties(
          ButtonRunProperties,
          isRemoteView === true ? undefined : backButtonProperties,
          titleMenuProperties,
          secondaryButton,
        );
      }
    } else {
      let Button1Props;
      let Button2Props;
      const pauseresumebutton = isPCPaused ? ButtonContinueProps : ButtonPauseProps;
      const continueCancelManualControl =
        isManualControlRunning === APPDATA.ENUM.MANUAL_CONTROL_STATE.ENABLE
          ? ButtonStopManualControl
          : ButtonContinueProps;

      if (String(isManualControlEnable) === 'true') {
        switch (ManualControlState) {
          case MANUAL_CONTROL_ENUM.DEFAULT_VOLUME_MANUAL_CONTROL:
          case MANUAL_CONTROL_ENUM.CUSTOM_VOLUME_MANUAL_CONTROL:
            Button1Props = continueCancelManualControl;
            Button2Props = ButtonFinishProps;
            break;
          case MANUAL_CONTROL_ENUM.HOLD_TO_RUN:
            Button1Props = ButtonHoldToRunProps;
            Button2Props = ButtonFinishProps;
            break;
          default:
            break;
        }
      } else {
        Button1Props = pauseresumebutton;
        Button2Props = ButtonStopProps;
      }

      backButtonProperties.disabled = true;

      this.setDoubleTopMenuProperties(
        Button1Props,
        Button2Props,
        isRemoteView === true ? undefined : backButtonProperties,
        titleMenuProperties,
        secondaryButton,
      );
    }
  };

  setSingleTopMenuProperties = (
    topButtonProperties,
    backButtonProperties,
    titleMenuProperties,
    topButtonSecondaryButtonProperties,
  ) => {
    const {dispatch} = this.props;

    dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
                className: topButtonProperties.className,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
        topButtonSecondaryButtonProperties,
      }),
    );
  };

  setDoubleTopMenuProperties = (
    button1Properties,
    button2Properties,
    backButtonProperties,
    titleMenuProperties,
    resetDefaultProperties,
  ) => {
    const {dispatch} = this.props;

    dispatch(
      setupActions.setDoubleTopMenuProperties({
        button1Properties:
          button1Properties === undefined
            ? undefined
            : {
                id: button1Properties.id,
                label: button1Properties.label,
                onClick: button1Properties.onClick,
                disabled: button1Properties.disabled,
                className: button1Properties.className,
                enableLongPress: button1Properties.enableLongPress,
                endLongPress: button1Properties.endLongPress,
                startLongPress: button1Properties.startLongPress,
              },
        button2Properties:
          button2Properties === undefined
            ? undefined
            : {
                id: button2Properties.id,
                label: button2Properties.label,
                onClick: button2Properties.onClick,
                disabled: button2Properties.disabled,
                className: button2Properties.className,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: '',
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
        topButtonSecondaryButtonProperties: resetDefaultProperties,
      }),
    );
  };

  onClickHelp = () => {
    this.setState({
      isHelpModeEnable: true,
    });
  };

  onClosePopUpWizard = () => {
    const {dispatch} = this.props;

    dispatch(setupActions.updateMessageAutoProfileHelpParam(APPDATA.HOME_HELP));
    this.setState({
      isHelpModeEnable: false,
      contentHelp: DataHelpHome,
    });
  };

  backAction = () => {
    this.goToHomeScreen();
  };

  endLongPressAction = () => {
    consoleLog('End Long Press');
    this.StopManualControlOnHold();
  };

  startLongPressAction = () => {
    consoleLog('start Long Press');
    this.StartManualControlOnHold();
  };

  onClick = async (e) => {
    const {isManualControlEnable, dispatch, currentPCState} = this.props;
    const {waitingPause} = this.state;

    switch (e.currentTarget.id) {
      case APPDATA.SCHEDULE_RUN:
        dispatch(postHighVolumeBuffer());
        dispatch(validateAutoProfileParamsBeforeSchedule());

        break;
      case APPDATA.RUN_NOW:
        dispatch(postHighVolumeBuffer());
        dispatch(validateAutoProfileParams());

        break;
      case 'AutoProfileHelp':
        this.onClickHelp();
        break;
      case RecoveryOfLiquidAction.STOP_NORMAL_PROCESS: {
        dispatch(loadingActions.showLoading(true));
        this.throttleStopAutoProfile();
        break;
      }
      case RecoveryOfLiquidAction.STOP_MANUAL_CONTROL:
        this.CancelManualControl();
        break;

      case APPDATA.PAUSE.toUpperCase():
        if (!waitingPause) {
          this.setState({
            waitingPause: true,
          });

          if (currentPCState !== APPDATA.PC_PREPARING_STATE) {
            dispatch(loadingActions.showLoading(true));
            await dispatch(pauseAutoProfile());
          }
          this.setState({
            waitingPause: false,
          });
        }
        break;
      case APPDATA.CONTINUE.toUpperCase():
        if (!waitingPause) {
          this.setState({
            waitingPause: true,
          });

          await dispatch(resumeAutoProfile());
          this.setState({
            waitingPause: false,
          });
        }
        break;
      case APPDATA.FINISH:
        if (isManualControlEnable === 'true') {
          this._bus.publish(RecoveryOfLiquidEvent.SHOW_POP_UP, {
            recoveryAction: RecoveryOfLiquidAction.STOP_MANUAL_CONTROL,
          });
        }
        break;
      case 'HOLD_TO_RUN':
        dispatch(startManualControl());
        break;

      case APPDATA.DISCARD:
        dispatch(setupActions.updateProfileList(true));
        this.closePopUp();
        break;
      case APPDATA.NO:
      case APPDATA.OK:
        this.closePopUp();
        break;
      default:
        break;
    }
  };

  // subscriber
  EnableManualUpdate = () => {
    const {RequestPendingManualControl, PostEnableManualUpdate} = this.props;

    if (!RequestPendingManualControl) {
      PostEnableManualUpdate();
    }
  };

  StopManualControl = () => {
    const {RequestPendingManualControl, PostStopManualUpdate} = this.props;

    if (!RequestPendingManualControl) {
      PostStopManualUpdate();
      this.onChangeTopButtonProps(MANUAL_CONTROL_ENUM.DEFAULT_VOLUME_MANUAL_CONTROL);
    }
  };

  CancelManualControl = () => {
    const {RequestPendingManualControl, PostCancelManualControl} = this.props;

    if (!RequestPendingManualControl) PostCancelManualControl();
  };

  StartManualControlOnHold = () => {
    const {dispatch} = this.props;

    dispatch(startManualControlOnHold());
  };

  StopManualControlOnHold = () => {
    const {dispatch} = this.props;
    dispatch(stopManualControlOnHold());
  };

  goToHomeScreen = () => {
    this.setupTopMenuHiddenHelpProperties(false);
    window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
  };

  pauseSuccess = () => {
    this.setState({
      waitingPause: false,
    });
  };

  pauseFailed = () => {
    const {dispatch} = this.props;

    this.setState({
      waitingPause: false,
    });
    dispatch(loadingActions.showLoading(false));
  };

  resumeSuccess = () => {
    this.setState({
      waitingPause: false,
    });
  };

  resumeFailed = () => {
    this.setState({
      waitingPause: false,
    });
  };

  onChangeTopButtonProps = (manualControlType) => {
    const {dispatch} = this.props;

    dispatch(updateManualControlState(manualControlType));
  };

  render() {
    const {fontSize} = this.props;
    const {contentHelp, isHelpModeEnable} = this.state;

    return (
      <PopUpWizard
        data={contentHelp}
        fontSize={fontSize}
        popUpWizardVisible={isHelpModeEnable}
        onClose={this.onClosePopUpWizard}
      />
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  PostEnableManualUpdate: bindActionCreators(PostEnableManualUpdate, dispatch),
  PostStartManualUpdate: bindActionCreators(PostStartManualUpdate, dispatch),
  PostStopManualUpdate: bindActionCreators(PostStopManualUpdate, dispatch),
  PostCancelManualControl: bindActionCreators(PostCancelManualControl, dispatch),
});

export default connect(null, mapDispatchToProps)(AutoProfileTopMenu);
